export enum AddressType {
    DELIVERYADDRESS = 'DELIVERYADDRESS',
    BILLINGADDRESS = 'BILLINGADDRESS'
  }